import { formatStringByObject, adjustTimezone } from 'Root/helpers/tools';

const MESSAGES = {
  order_done: ({ order }) => `Order ${order} completed`,
  order_canceled: ({ order }) => `The customer canceled the order ${order}`,
  order_problem: ({ order }) => `Order ${order} has problem`,
  order_on_auction: ({ order }) => `The new order ${order} is available for your category`,
  order_expired_deadline: ({ order }) => `The order ${order} has expired due date`,
  order_approaching_deadline: ({ order }) => `Order ${order} has 24 hours left`,
  order_transferred_to_status_in_progress: ({ order }) => `You received a new order ${order}`,
  order_in_warranty: ({ order }) => `Order ${order} transferred to warranty`,
  order_was_returned: ({ order }) => `Order ${order} was returned`,
  balance_funds_available: ({ amount }) => `Now available ${amount} on your account`,
  balance_funds_credited: ({ amount }) => `Your account received ${amount}`,
  balance_funds_withdrawn: ({ amount }) => `From your account debited ${amount}`,
  profile_approved: () => 'You have passed verification',
  profile_blocked: ({ reason }) => `You are blocked. Reason: ${reason}`,
  profile_declined: () => 'Verification reopened/failed',
  profile_on_revision: () => 'Verification reopened/failed',
  payout_approved: ({ payoutId }) => `Withdrawal request ID ${payoutId} was confirmed`,
  payout_canceled: ({ payoutId }) => `Withdrawal request ID ${payoutId} was canceled`,
  payout_declined: ({ payoutId }) => `Withdrawal request ID ${payoutId} was declined`,
  payout_error: ({ payoutId }) => `Withdrawal request ID ${payoutId} error`,
  order_executor_was_changed: ({ order }) => `Your order ${order} is reassigned`,
  order_transferred_to_status_waiting_for_executor: ({ order }) => `Order ${order} assigned to you`,
  new_message: ({ orderId }) => `New Message for your order ${orderId}`,
  order_status_changed_in_warranty: ({ orderId }) => `Order ${orderId} successfully completed!`,
  order_status_changed_executor_assigned: ({ orderId }) => `Pro is ready. Discuss ${orderId} details`,
};

const MESSAGES_WITH_OBJECT_INFO = {
  /* eslint-disable no-template-curly-in-string */
  balance_funds_available: 'Now available ${amount} for {object.object_type} {object.object_id} on your account',
  balance_funds_credited: 'Your account received ${amount} for {object.object_type} {object.object_id}',
  balance_funds_withdrawn: 'From your account debited ${amount} for {object.object_type} {object.object_id}',
  /* eslint-enable no-template-curly-in-string */
};

class Notification {
  constructor(notification) {
    this.notification = { ...notification };
    this.notification.description = Notification.getMessage(this.notification.type, this.notification.message_data);

    // дата создания
    const createdAt = this.notification.created_at
      ? adjustTimezone(new Date(this.notification.created_at))
      : Date.now();

    this.notification.createdAtFormatted = Notification.formatCreatedAt(createdAt);

    return this.notification;
  }

  static getMessage(messageKey, dataObject) {
    if (!MESSAGES[messageKey]) {
      return null;
    }

    let message = MESSAGES[messageKey](dataObject);
    if (typeof dataObject === 'object') {
      // если передана информация о связанном объекте
      if (dataObject.object && MESSAGES_WITH_OBJECT_INFO[messageKey]) {
        message = MESSAGES_WITH_OBJECT_INFO[messageKey];
      }

      return formatStringByObject(message, dataObject);
    }

    return message;
  }

  static formatCreatedAt(createdAt) {
    const dateFormat = new Intl.DateTimeFormat('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    const date = new Date(createdAt);
    const [
      { value: month },,
      { value: day },,
      { value: year },,
      { value: hour },,
      { value: minute },
    ] = dateFormat.formatToParts(date);

    return {
      day: `${day}.${month}.${year}`,
      time: `${hour}:${minute}`,
    };
  }
}

export default Notification;
